// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"a26b7cd7","285":"85d95464","505":"f8bef399","611":"eb9849f3","631":"ac1816e5","652":"33884191","934":"4c5c4de3"}[chunkId] + ".chunk.js";
};